/// <reference path="../Lead/LeadGrid.ts" />

namespace Nobox.Nobox {

    import fld = LeadRow.Fields;

    @Serenity.Decorators.registerClass()
    export class ListLeadGrid extends LeadGrid {
        protected getDialogType() { return LeadDialog; }

        constructor(container: JQuery) {
            super(container); 
        }

        protected initEntityDialog(itemType, dialog) {
            super.initEntityDialog(itemType, dialog);
            Serenity.SubDialogHelper.cascade(dialog, this.element.closest('.ui-dialog'));
        }

        protected addButtonClick() {
            this.editItem({ ListId: this.listId });
        }


        protected getPersistanceStorage(): Serenity.SettingStorage {
            return window.localStorage;
        }

        //protected getButtons() {
        //    var buttons = super.getButtons();
        //    var $this = this;
        //    buttons[0].onClick = function () {
        //        var dlg = new LeadDialog();
        //        dlg.loadEntityAndOpenDialog({ ListId: $this.listId })
        //    }
        //    return buttons;
        //}

        protected getInitialTitle() {
            return null;
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this.listId;
        }

        private _ListID: string;

        get listId() {
            return this._ListID;
        }
        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit()) { return false; }
            let request = this.view.params as Serenity.ListRequest;
            //request.ColumnSelection = 1;
            request.Criteria = Serenity.Criteria.and(request.Criteria, [[fld.ListId], 'like', '%' + this.listId + '%']); return true;
        }
        set listId(value: string) {
            if (this._ListID !== value) {
                this._ListID = value;
                this.refresh();
            }
        }
        protected getViewOptions() {
            let opt = super.getViewOptions();
            opt.rowsPerPage = 20;
            return opt;
        }
        protected getPagerOptions() {
            let opt = super.getPagerOptions();
            opt.rowsPerPageOptions = [10, 20, 50, 100, 500, 1000];
            return opt;
        }
    }
}